import { put } from '../..';
import asNumber from '../../../components/AsNumber';

type EditAreaPayload = {
  LocationId: string,
  Area: {
    Name: string,
    Top: number,
    Left: number,
    Right: number,
    Bottom: number,
    Points,
    Polygon,
    Priority: boolean,
    ParentId: string,
    LocationSubtype?: string | null,
    LocationCapacity?: number | null,
    ExternalId?: string,
  },
}

const editArea = ({
  LocationId,
  Area: {
    Name, Top, Left, Right, Bottom, Points, Polygon, Priority, ParentId, LocationSubtype,
    LocationCapacity, ExternalId,
  },
}: EditAreaPayload) => {
  // Ensure Points is correctly processed for API
  const parsedPoints = [];
  if (Points && Array.isArray(Points)) {
    Points.forEach((point) => {
      if (point) {
        parsedPoints.push({
          X: point.x,
          Y: point.y,
          Number: point.number !== undefined ? point.number : parsedPoints.length,
        });
      }
    });
  }

  const body: EditAreaPayload = {
    Area: {
      Name,
      Top,
      Left,
      Right,
      Bottom,
      Points: parsedPoints,
      Polygon,
      Priority,
      ParentId,
    },
    LocationId,
  };

  if (LocationSubtype?.length > 0 && typeof LocationSubtype === 'string') {
    body.Area.LocationSubtype = LocationSubtype;
  }

  if (ExternalId?.length > 0 && typeof ExternalId === 'string') body.Area.ExternalId = ExternalId;

  if (asNumber(LocationCapacity)) {
    body.Area.LocationCapacity = asNumber(LocationCapacity);
  }

  return put('locations/areas', body);
};

export default editArea;
